[
  {
    "dia": "14M",
    "mupi": 1,
    "hora": "10h25min",
    "numero": 1,
    "titulo": "Energy Drinks and Pre-Workout Supplements: An Analysis of pH Levels Through an In Vitro Study",
    "autor": "Laura Marqués Martínez"
  },
  {
    "dia": "14M",
    "mupi": 1,
    "hora": "10h32min",
    "numero": 2,
    "titulo": "Caracterização óptica e efeito antimicrobiano do Pelargonium sidoides associado à luz na endodontia",
    "autor": "Sâmmea Martins Vieira"
  },
  {
    "dia": "14M",
    "mupi": 1,
    "hora": "10h39min",
    "numero": 3,
    "titulo": "Avaliação da biocompatibilidade de cimentos endodônticos",
    "autor": "Patricia Ribeiro"
  },
  {
    "dia": "14M",
    "mupi": 1,
    "hora": "10h46min",
    "numero": 4,
    "titulo": "Desenvolvimento de sistema experimental de impacto para avaliação do desempenho de protetores bucais",
    "autor": "Diana Angélica Fernandes"
  }
]